import { getStore } from '../store/composeStore';
import upConvert from './upConvert';
import { action } from 'satcheljs/lib/legacy';
export default action('floatCompose')(function (viewState, type) {
    if (!viewState) {
        return;
    }
    var state = getStore();
    // floatCompose can put any composeViewState into floatingViewStates and set its floating type
    // if the viewState is defaultViewState/pendingViewState originally, need to remove it
    if (viewState == state.defaultViewState) {
        state.defaultViewState = null;
    }
    else if (viewState == state.pendingViewState) {
        state.pendingViewState = null;
    }
    // Only support full compose in floating mode for now. If it is inline compose, upConvert to full compose
    if (viewState.isInlineCompose) {
        upConvert(viewState);
    }
    // Don't use async send for floating compose since there can be multiple floating compose
    viewState.preferAsyncSend = false;
    // add the viewState into floatingViewStates if it is not there
    var floatingViewState = state.floatingViewStates.get(viewState.composeId);
    if (!floatingViewState) {
        floatingViewState = {
            type: 0 /* Normal */,
            zIndex: 0,
            composeViewState: viewState,
        };
        state.floatingViewStates.set(viewState.composeId, floatingViewState);
    }
    floatingViewState.type = type;
});
//# sourceMappingURL=floatCompose.js.map